import { z } from 'zod';
/**
 * Creating the CRM record for a customer that has none yet.
 *
 * The name is required and non-empty on purpose: HubSpot happily creates a
 * company with no properties at all, and a nameless one is indistinguishable
 * from an accident and findable by nobody.
 */ export const AddHubspotCompanyRequestSchema = z.object({
    name: z.string().trim().min(1, 'Name is required'),
    domain: z.string().trim().optional()
});
export const AddHubspotCompanyResponseSchema = z.object({
    companyId: z.string(),
    name: z.string(),
    domain: z.string().nullable()
});

//# sourceMappingURL=add-hubspot-company.schema.js.map